import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';

export enum KnowledgeQuestionType {
  单选题 = 1,
  多选题 = 2,
}

export interface IKnowledgeBank {
  name: string;
  type: KnowledgeQuestionType;
  id: number;
  createdTime: string;
}

export interface IKnowledgeBankSaveParams {
  id?: number;
  name: string;
  type: KnowledgeQuestionType;
}
export interface IKnowledgeBankGetExcelTemplateParams {
  type: KnowledgeQuestionType;
}
export interface IQueryByBankIdParams {
  bankId: number;
}

export default class UseKnowledgeBank {
  static save() {
    return usePost<IKnowledgeBankSaveParams, IKnowledgeBank>('knowledgeBank/save', {});
  }
  static list() {
    return useGet<void, IKnowledgeBank[]>('knowledgeBank/list', {});
  }
  static queryById() {
    return useGet<IQueryByIdParams, IKnowledgeBank>('knowledgeBank/queryById', {});
  }
  static getExcelTemplate() {
    return useGet<IKnowledgeBankGetExcelTemplateParams, {url: string}>('knowledgeBank/getExcelTemplate', {});
  }
  static listQuestion() {
    return useGet<IQueryByBankIdParams, IKnowledgeBank>('knowledgeQuestion/listByBankId', {});
  }
}
